import {
  StrapiActionTypes,
  StrapiItem,
  AddRequestAction,
  AddSuccessAction,
  AddFailureAction,
  SetLastAddedIdAction,
  UpdateRequestAction,
  UpdateSuccessAction,
  UpdateFailureAction,
  DeleteRequestAction,
  DeleteSuccessAction,
  DeleteFailureAction,
  SetLastDocIdAction
} from '../../types/strapiVPO';


export const addDataVPO = (modelName: string, data: any, creatorId?: string): AddRequestAction => ({
  type: StrapiActionTypes.ADD_REQUEST_VPO,
  payload: {
    modelName,
    data,
    creatorId,
  },
});

export const addDataVPOSuccess = (modelName: string, data: StrapiItem, creatorId?: string): AddSuccessAction => ({
  type: StrapiActionTypes.ADD_SUCCESS_VPO,
  payload: {
    modelName,
    data,
    creatorId,
  },
});

export const addDataVPOFailure = (modelName: string, error: string): AddFailureAction => ({
  type: StrapiActionTypes.ADD_FAILURE_VPO,
  payload: {
    modelName,
    error,
  },
});

export const setLastAddedId = (modelName: string, id: number | null): SetLastAddedIdAction => ({
  type: StrapiActionTypes.SET_LAST_ADDED_ID_VPO,
  payload: {
    modelName,
    id,
  },
});

export const updateDataVPO = (modelName: string, documentId: string, data: any): UpdateRequestAction => ({
  type: StrapiActionTypes.UPDATE_REQUEST_VPO,
  payload: {
    modelName,
    documentId,
    data,
  },
});

export const updateDataVPOSuccess = (modelName: string, data: StrapiItem): UpdateSuccessAction => ({
  type: StrapiActionTypes.UPDATE_SUCCESS_VPO,
  payload: {
    modelName,
    data,
  },
});

export const updateDataVPOFailure = (modelName: string, error: string): UpdateFailureAction => ({
  type: StrapiActionTypes.UPDATE_FAILURE_VPO,
  payload: {
    modelName,
    error,
  },
});

export const deleteDataVPO = (modelName: string, documentId: string): DeleteRequestAction => ({
  type: StrapiActionTypes.DELETE_REQUEST_VPO,
  payload: {
    modelName,
    documentId,
  },
});

export const deleteDataVPOSuccess = (modelName: string, documentId: string): DeleteSuccessAction => ({
  type: StrapiActionTypes.DELETE_SUCCESS_VPO,
  payload: {
    modelName,
    documentId,
  },
});

export const deleteDataVPOFailure = (modelName: string, error: string): DeleteFailureAction => ({
  type: StrapiActionTypes.DELETE_FAILURE_VPO,
  payload: {
    modelName,
    error,
  },
});

export const setLastDocId = (modelName: string, documentId: string | null): SetLastDocIdAction => ({
  type: StrapiActionTypes.SET_LAST_DOC_ID_VPO,
  payload: {
    modelName,
    documentId,
  },
});

export const fetchActionByContextRequest = (modelName: string, context: any) => ({
  type: StrapiActionTypes.FETCH_ACTION_BY_CONTEXT_REQUEST_VPO,
  payload: { modelName, context },
});

export const fetchActionByContextSuccess = (data: any[]) => ({
  type: StrapiActionTypes.FETCH_ACTION_BY_CONTEXT_SUCCESS_VPO,
  payload: { data },
});

export const fetchActionByContextFailure = (error: string) => ({
  type: StrapiActionTypes.FETCH_ACTION_BY_CONTEXT_FAILURE_VPO,
  payload: { error },
});

export const fetchInconsistenciesByActionIdRequest = (actionId: number) => ({
  type: StrapiActionTypes.FETCH_INCONSISTENCIES_BY_ACTION_REQUEST_VPO,
  payload: { actionId },
});

export const fetchInconsistenciesByActionIdSuccess = (data: any[]) => ({
  type: StrapiActionTypes.FETCH_INCONSISTENCIES_BY_ACTION_SUCCESS_VPO,
  payload: { data },
});

export const fetchInconsistenciesByActionIdFailure = (error: string) => ({
  type: StrapiActionTypes.FETCH_INCONSISTENCIES_BY_ACTION_FAILURE_VPO,
  payload: { error },
});

export const clearInconsistenciesByAction = () => ({
  type: StrapiActionTypes.CLEAR_INCONSISTENCIES_BY_ACTION_VPO,
});